import React, {useContext, useEffect, useState} from "react";
import PageLayout from "../../components/Patricia/PageLayout/PageLayout";
import {StateContext} from "../../app/state";
import {Button} from "../../components/Button/Button";
import {
    patriciaAiUpdateOrder,
} from "../../app/actions";
import UiKit from "uikit";
import {
    MobileView, BrowserView,
    isMobile
} from "react-device-detect";
import DesignPackageProductsModal from "../../components/Wem/DesignPackageProductsModal";

function WemShoppingCart(props){
    const context = useContext(StateContext);
    const [
        {
            localization: { patricia: lang },
            auth: { user },
            data: { shoppingCart },
        },
    ] = context;
    const modalId = "design-package-id";
    const dir = user && user.locality === "he-il" ? "rtl" : "ltr";
    const [loading, setLoading] = useState(false);
    const [isShoppingCartNotEmpty, setIsShoppingCartNotEmpty] = useState(false);
    const [designPackage, setDesignPackage] = useState(null);
    const wemLogo = 'https://d13q6nh6jdm5x9.cloudfront.net/Media/54fcb8a0-ac0d-11eb-939f-373014a71565/3670d780-b2f2-11eb-977b-b79322b1e9ec_thumb.jpg';

    useEffect(() => {
        if(shoppingCart && shoppingCart.design_package) {
            setDesignPackage(shoppingCart.design_package)
            setIsShoppingCartNotEmpty(shoppingCart && shoppingCart.design_package != null);
        }
    }, [shoppingCart])


    function deleteDesignPackageFromOrder(e){
        e.preventDefault();
        const formData = new FormData();
        formData.append('design_package_id', "");
        setLoading(true);
        patriciaAiUpdateOrder({id: shoppingCart.id, payload: formData}, (res) => {
            setIsShoppingCartNotEmpty(false);
            setDesignPackage(null);
        }, (error) => {
            console.log(error);
        });
    }

    function onContinueClicked(e){
        e.preventDefault();
        props.history.push(`/shipping`);
    }

    function onGoToMyHomeLink(e){
        e.preventDefault();
        props.history.push(`/properties/${user.consumer.properties[0].id}?relation[]=consumer&relation[]=project&relation[]=media&retailer`);
    }

    function onDesignPackageClicked(e) {
        e.preventDefault();
        e.stopPropagation();
        UiKit.modal(`#${modalId}`).show();
    }
    function onCloseProductModal(e) {
        e.preventDefault();
        e.stopPropagation()
    }
    return (
        <PageLayout>
            <div className='uk-flex uk-padding-large uk-padding-remove-bottom uk-flex-between'>
                <h1 className="">{lang.shoppingCart.header}</h1>
                <div>
                    <Button cssClasses="patricia-ai-color uk-button-large" label={lang.shoppingCart.actions.continue} type="primary" onClick={onContinueClicked}></Button>
                </div>
            </div>
            {!isShoppingCartNotEmpty ?
                <div className='uk-text-center'>
                    <div className='uk-margin-medium-bottom'>{lang.shoppingCart.messages.emptyCart}</div>
                    <button className="uk-button uk-button-small uk-width-small reg-next-button" onClick={onGoToMyHomeLink}>{lang.shoppingCart.actions.myHome}</button>
                </div>
                :
                <table className="uk-table uk-table-divider uk-width-3-4 uk-margin-auto">
                    <BrowserView>
                        <thead className=''>
                        <tr>
                            <th className="uk-table-expand uk-text-center patricia-ai-text-color" style={{fontWeight: "bold"}}>{lang.shoppingCart.headers.name}</th>
                            <th className="uk-table-expand uk-text-center patricia-ai-text-color" style={{fontWeight: "bold"}}>{lang.shoppingCart.headers.provider}</th>
                            <th className="uk-table-expand uk-text-center patricia-ai-text-color" style={{fontWeight: "bold"}}>{lang.shoppingCart.headers.price}</th>
                            <th className="uk-table-expand uk-text-center patricia-ai-text-color" style={{fontWeight: "bold"}}></th>
                        </tr>
                        </thead>
                        <tbody className="uk-text-center">
                            <tr key={designPackage.id} className='uk-child-width uk-box-shadow-hover' style={{  cursor: "pointer"}} >
                                <td className='uk-width-1-3 uk-text-small' style={{verticalAlign: "middle"}} onClick={(e) => onDesignPackageClicked(e)}>{designPackage.name}</td>
                                <td className='uk-width-1-3 uk-text-small' style={{verticalAlign: "middle"}} onClick={(e) => onDesignPackageClicked(e)}>
                                    <img className="uk-margin-left" height="150" width="100" src={wemLogo}/>
                                </td>
                                <td className='uk-width-1-3 uk-text-small' style={{verticalAlign: "middle"}} onClick={(e) => onDesignPackageClicked(e)}>{designPackage.price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")} &#8362;</td>
                                <td className='uk-width-1-3 uk-text-small' style={{verticalAlign: "middle"}}>
                                    <a className="uk-margin-small-left" uk-icon="icon: trash" onClick={(e) => deleteDesignPackageFromOrder(e)}></a>
                                </td>
                            </tr>
                        </tbody>
                    </BrowserView>
                    <MobileView>
                        <tbody className="uk-height-large">
                            <div className='uk-padding-large uk-padding-remove-bottom uk-padding-remove-top'>
                                <div className='uk-text-small uk-margin-small-bottom' onClick={(e) => onDesignPackageClicked(e,)}>{designPackage.name}</div>
                                <div className="uk-margin-bottom uk-grid-medium" uk-grid="">
                                    <div className='uk-width-1-3 uk-flex uk-flex-column uk-flex-center uk-text-center'>
                                        <div className='uk-text-small uk-text-center uk-margin-small-bottom' onClick={(e) => onDesignPackageClicked(e)}>
                                            <img className="uk-margin-left" height="120" width="120" src={wemLogo}/>
                                        </div>
                                    </div>
                                    <div className='uk-width-2-3 uk-padding-remove-left uk-flex uk-flex-column uk-flex-center'>
                                        <div className='uk-text-small uk-margin-small-bottom' style={{paddingRight: "30px"}} onClick={(e) => onDesignPackageClicked(e)}>
                                            <span className='uk-text-bold'>{lang.shoppingCart.headers.price}: </span> {designPackage.price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")} &#8362;
                                        </div>
                                        <div className='uk-text-small uk-margin-small-bottom' style={{paddingRight: "30px"}}>
                                            <a className="uk-margin-small-left" uk-icon="icon: trash" onClick={(e) => deleteDesignPackageFromOrder(e)}></a>
                                        </div>
                                    </div>
                                </div>
                                <hr/>
                            </div>
                        </tbody>
                    </MobileView>
                </table>
            }
            {isShoppingCartNotEmpty &&
            <div className={`uk-flex uk-margin-bottom ${!isMobile && "uk-flex-center"}`}>
                <div>
                    <Button cssClasses="patricia-ai-color uk-button-large uk-margin-small-right" label={lang.shoppingCart.actions.continue} type="primary" onClick={onContinueClicked}></Button>
                </div>
                <div className='uk-position-absolute uk-margin-small-bottom uk-margin-small-left' style={{left: 0}}><span className='uk-text-bold'>{lang.shoppingCart.summary.total}:</span> {(shoppingCart.total_price).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")} &#8362;</div>
            </div>}
            <DesignPackageProductsModal
                dir={user && user.lcoality === "he-il" ? "rtl" : ""}
                designPackage={designPackage}
                modalId={modalId}
            />
        </PageLayout>
    );
}

export default WemShoppingCart;